module.exports = __webpack_public_path__ + "img/picture2.b669813a.jpg";